import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { graphql } from 'gql';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

const uerWorkOrderWorkRatioInfoGql = graphql(`
    query uerWorkOrderWorkRatioInfo($workOrderId: Long!, $constructionTypeId: Int!) {
        uerWorkOrderWorkRatioInfo(workOrderId: $workOrderId, constructionTypeId: $constructionTypeId) {
            result
            message
            data {
                hasEmptyWorkRatios
            }
        }
    }
`);

const requestId = 'workOrderWorkRatioInfo';

export const useWorkOrderWorkRatioInfo = ({
    workOrderId,
    constructionTypeId,
}: {
    workOrderId: number;
    constructionTypeId: number;
}) => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            workOrderId,
            constructionTypeId,
        }),
        [workOrderId, constructionTypeId],
    );

    const [data, , , request] = useRequest({
        query: uerWorkOrderWorkRatioInfoGql,
        requestId,
        variables,
        withEffect: Boolean(workOrderId && constructionTypeId),
    });

    const [reset] = useResetStoreData({
        requestId,
    });

    useEffect(
        () => () => {
            reset(undefined);
        },
        [reset],
    );

    const refreshWorkRatioInfo = useCallback(() => {
        dispatch(request(variables));
    }, [dispatch, request, variables]);

    const { hasEmptyWorkRatios = false } = data?.uerWorkOrderWorkRatioInfo?.data || {};

    return {
        hasEmptyWorkRatios,
        refreshWorkRatioInfo,
    };
};
